import { Instance, types, getEnv, flow } from "mobx-state-tree";
import { reaction } from "mobx";

import { apiSubscriptionKey } from "../api/ApiSubscriptionKeyService";
import { appSessionStorage } from "../storage/SessionStorageService";
import { globalModule } from "../service-provider/GlobalModule";
import { StorageModel } from "../storage/StorageModel";
import { endpoints } from "../api/ApiEndpoints";
import { lastAccessedOrganizationService } from "./LastAccessedOrganizationStorage";

const OrganizationSubscriptionKey = "organizationSubscriptionKey";

const OrganizationSubscriptionModel = types.model({
  key: "",
});

export const OrganizationSubscriptionStorageModel = types
  .compose(OrganizationSubscriptionModel, StorageModel)
  .named("OrganizationSubscriptionStorageModel")
  .actions((self) => {
    function removeOrganizationSubscriptionKey() {
      getEnv(self).appSessionStorage.removeStorageItem(OrganizationSubscriptionKey);
    }
    return {
      removeOrganiztionSubscriptionKey: removeOrganizationSubscriptionKey,
      reloadOrganizationSubscription: flow(function* reloadOrganizationSubscription() {
        removeOrganizationSubscriptionKey();
        yield self.load();
      }),
    };
  })
  .views((self) => ({
    get endpoint() {
      return endpoints.get("organization_subscription_key");
    },
    get canLoadItems() {
      return getEnv(self).lastAccessedOrganizationService.data;
    },
    mapResponse(response: any) {
      self.data = response;
      self.key = response;
    },
  }));

export type OrganizationSubscriptionService = Instance<typeof OrganizationSubscriptionStorageModel>;
export const organizationSubscriptionService = OrganizationSubscriptionStorageModel.create(
  {
    cacheKey: OrganizationSubscriptionKey,
  },
  {
    api: apiSubscriptionKey,
    appSessionStorage: appSessionStorage,
    lastAccessedOrganizationService,
  }
);

globalModule.organizationSubscriptionService = organizationSubscriptionService;

reaction(
  () => lastAccessedOrganizationService.data,
  async () => {
    await organizationSubscriptionService.reloadOrganizationSubscription();
  }
);
